import React, { FunctionComponent } from 'react';

import UserTickets from 'pages/Home/components/UserTickets';
import UserChats from 'pages/Home/components/UserChats';
import HomePageTiles from 'pages/Home/components/HomePageTiles';

import useStyles from './styles';

const Home: FunctionComponent = () => {
  const classes = useStyles();

  return (
    <div className={classes.homePage}>
      <HomePageTiles />
      <div className={classes.twoInRow}>
        <UserTickets />
        <UserChats />
      </div>
    </div>
  );
};
export default Home;
